"use strict";

var _classCallCheck = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Request = __importStar(require("../stateful/request"));

var CrudRoutes = function CrudRoutes(urlPrefix) {
  var _this = this;

  _classCallCheck(this, CrudRoutes);

  this.list = function () {
    return Request.post("".concat(_this.urlPrefix, "/list"));
  };

  this.detail = function (uuid) {
    return Request.post("".concat(_this.urlPrefix, "/detail"), {
      id: Number(uuid)
    });
  };

  this.insert = function (data) {
    return Request.post("".concat(_this.urlPrefix, "/insert"), Object.assign({}, data));
  };

  this.update = function (data) {
    return Request.post("".concat(_this.urlPrefix, "/update"), Object.assign({}, data));
  };

  this.deleteById = function (id) {
    return Request.post("".concat(_this.urlPrefix, "/delete"), {
      id: id
    });
  };

  this.urlPrefix = urlPrefix;
};

exports.default = CrudRoutes;